import React from 'react'
import Typography from '@mui/material/Typography'
import PrintDownload from './printAndDownload'
import CancelRefund from './cancelAndRefund'
import Email from './resendEmail'
import RedeemTickets from './redeemTickets'
import { FillDetailsButton } from './fillDetails/fillDetalsButton'
import { SentEmailsButton } from './sentEmails/SentEmailsButton'
import { ReplaceMessagesFunc } from 'messagesContext'
import './index.scss'
import { useTranslation } from 'translations'

interface OrderTicketsActionsProps {
    hideMessage: (id: string) => void
    replaceMessages: ReplaceMessagesFunc
}

const OrderTicketsActions: React.FC<OrderTicketsActionsProps> = ({ replaceMessages, hideMessage }) => {
    const { t } = useTranslation()
    return (
        <div className="actions-container">
            <Typography variant="body1" className="actions-caption">
                {t('orders.orders.ticketActions.caption')}
            </Typography>
            <FillDetailsButton />
            <PrintDownload />
            <Email />
            <RedeemTickets replaceMessages={replaceMessages} hideMessage={hideMessage} />
            <SentEmailsButton />
            <CancelRefund />
        </div>
    )
}

export default OrderTicketsActions
